import styled from 'styled-components'

import { tokens } from '../../../assets/tokens'

const { color } = tokens

// Formulario de videoentrevista con la estructura de Velora: cabecera de página (título 20/600 y
// descripción), una tarjeta (radio 6, padding 24) con secciones de título 16/600, labels 14/500 y
// acciones al pie alineadas a la derecha
const EvaluativeTestsCreateStyled = styled.div`
  .title-container {
    padding: 30px 60px 0;
  }

  .button-custom {
    border-radius: 10px;
    color: ${color.text.onDark};
  }

  .button-with-icon {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;

    svg {
      flex-shrink: 0;
    }
  }

  /* Formulario centrado en la página, como antes del restyling */
  .create-container {
    max-width: 960px;
    margin: 0 auto;
    padding: 24px 60px 40px;
  }

  .page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 24px;
  }

  .page-header-text {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .title-create-test {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    color: ${color.text.primary};
  }

  .description-create-test {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: ${color.text.tertiary};
  }

  .form-card {
    display: flex;
    flex-direction: column;
    padding: 24px;
    background: ${color.background.default};
    border-radius: 6px;
    box-shadow: 0 4px 6px rgba(98, 102, 113, 0.06), 0 2px 2px rgba(98, 102, 113, 0.06);
  }

  .form-section {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding-bottom: 24px;

    & + .form-section {
      padding-top: 24px;
      border-top: 1px solid ${color.border.subtle};
    }
  }

  .section-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
  }

  .section-title {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: ${color.text.primary};
  }

  .section-description {
    margin: 4px 0 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: ${color.text.tertiary};
  }

  .form-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px 24px;

    @media (max-width: 900px) {
      grid-template-columns: 1fr;
    }
  }

  .form-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
  }

  .form-field-full {
    grid-column: 1 / -1;
  }

  .label-required {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: ${color.text.primary};

    &::after {
      content: '*';
      color: ${color.error.main};
      padding-left: 2px;
    }
  }

  .questions-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .container-questions {
    display: flex;
    align-items: flex-start;
    gap: 12px;
  }

  .question-number {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    margin-top: 8px;
    font-size: 12px;
    font-weight: 500;
    line-height: 24px;
    text-align: center;
    color: ${color.text.tertiary};
    background: ${color.background.light};
    border-radius: 50%;
  }

  .textarea-question {
    flex: 1;
    min-width: 0;
    min-height: 40px;
    padding: 9px 12px;
    font-family: ${tokens.typography.fontFamily.primary};
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: ${color.text.primary};
    background: ${color.background.default};
    border: 1px solid ${color.border.default};
    border-radius: 6px;
    box-sizing: border-box;
    outline: none;
    resize: vertical;

    :focus {
      border-color: ${props => props.theme.primary};
    }

    ::placeholder {
      color: ${color.text.disabled};
    }
  }

  .question-time {
    flex-shrink: 0;
    width: 130px;
  }

  .question-remove {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    margin-top: 4px;
    color: ${color.text.tertiary};
    border-radius: 6px;

    :hover {
      color: ${color.error.main};
      background-color: ${color.background.light};
    }
  }

  .wrapper-content-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding-top: 24px;
    border-top: 1px solid ${color.border.subtle};
  }

  .alert-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
  }

  .MuiCircularProgress-root {
    width: 25px !important;
    height: 25px !important;
  }
`
export default EvaluativeTestsCreateStyled
